module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button-dropdown', {
    attrs: {
      "infos": _vm.infos,
      "defaultOption": _vm.actualField
    },
    on: {
      "change": _vm.changeOrder
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15bf845d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/SortSelect.vue
// module id = 2933
// module chunks = 0